/**
 * Vuex "group" module (registered as `org` in the root store).
 *
 * Aggregates organization/group functionality: org CRUD, membership
 * (invites, join requests, roles, bans), channel following, and group
 * feed posts, split across state (store.js), actions (operations.js),
 * getters (selectors.js), and mutations (updates.js).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
